module.exports = __webpack_public_path__ + "static/media/sapb1.79c248e2.png";